import React from "react";

import { CSSGrid } from "@components/Layout/CssGrid";

import { Heading } from "./Heading";
import { Image } from "./Image";

const areas = CSSGrid.areas({ Image, Heading });

areas.all(({ Heading, Image }, { repeat }) => [
  repeat(Heading, 12),
  repeat(Image, 12),
]);

areas.smallTablet(({ Heading, Image }, { repeat, compose }) => [
  compose(repeat(Image, 6), repeat(Heading, 6)),
]);

export const Intro = () => {
  return <CSSGrid areas={areas} />;
};
